/**
 * Entity P&L month rows on ONE basis (Fan, 2026-10-25): the same actuals the
 * dashboard stat cards sum (lib/entityStatCards.js) and the backend's
 * services/entity_pnl.ytd_actuals.
 *
 *   revenue = BR OS invoiced revenue (revenue_actual) + Portfolio gross
 *             booking revenue (gross_revenue_actual; a month is actual once
 *             it is the current month or earlier)
 *   net     = net_result_actual
 *   costs   = revenue - net
 *
 * Months after the current month are forecast and are not rows here (the
 * Net Profit chart shows them as forecast bars). The table total and the
 * stat cards are the sum of these rows, so they can never disagree.
 */
import { brosRevenueActual, brosCogsActual } from './entityStatCards';

function n(v) {
  var x = parseFloat(v);
  return isNaN(x) ? 0 : x;
}

export function currentMonthKey(now) {
  var d = now || new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
}

export function entityPnlRow(m) {
  var hasBros = m.revenue != null || m.cogs != null;
  var hasPortfolio = m.gross_revenue != null;
  var brosRev = hasBros ? brosRevenueActual(m) : 0;
  var ppRev = hasPortfolio
    ? (m.gross_revenue_actual != null ? n(m.gross_revenue_actual) : n(m.gross_revenue))
    : 0;
  var revenue = brosRev + ppRev;
  var net = m.net_result_actual != null ? n(m.net_result_actual) : n(m.net_result);
  return {
    month: m.month,
    label: m.label,
    revenue: revenue,
    bros_revenue: brosRev,
    portfolio_revenue: ppRev,
    cogs: hasBros ? brosCogsActual(m) : 0,
    invoice_financing: n(m.invoice_financing),
    entity_opex: n(m.entity_opex),
    ota_commission: m.ota_commission_actual != null ? n(m.ota_commission_actual) : n(m.ota_commission),
    management_fees: n(m.management_fees),
    cleaning: n(m.cleaning),
    repairs: n(m.repairs),
    other_operational: n(m.other_operational),
    financing: n(m.financing),
    costs: revenue - net,
    net: net,
  };
}

export function entityPnlYtdRows(months, year, now) {
  var cur = currentMonthKey(now);
  var y = String(year);
  return (months || [])
    .filter(function (m) {
      var mk = m.month || '';
      return mk.slice(0, 4) === y && mk <= cur;
    })
    .map(entityPnlRow);
}

export function sumRows(rows) {
  var keys = ['revenue', 'bros_revenue', 'portfolio_revenue', 'cogs', 'invoice_financing',
    'entity_opex', 'ota_commission', 'management_fees', 'cleaning', 'repairs',
    'other_operational', 'financing', 'costs', 'net'];
  var out = {};
  keys.forEach(function (k) {
    out[k] = (rows || []).reduce(function (s, r) { return s + (r[k] || 0); }, 0);
  });
  return out;
}

export function pnlSources(months) {
  var ms = months || [];
  return {
    bros: ms.some(function (m) { return m.cogs != null || m.revenue != null; }),
    portfolio: ms.some(function (m) { return m.gross_revenue != null; }),
  };
}
